import './vue-hooks';
import 'intersection-observer';
import Vue from 'vue';
import App from './App.vue';
import router from '@/router';
import store from '@/store';
import { sync } from 'vuex-router-sync';
import VueScrollTo from 'vue-scrollto';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import VueKonva from 'vue-konva';

import lang from 'element-ui/lib/locale/lang/en';
import locale from 'element-ui/lib/locale';
import Meta from 'vue-meta';
import VueI18n from 'vue-i18n';
import { translationSvc } from '@/services';
import Constants from '@/constants';

// configure element-ui language
locale.use(lang);

import {
  DatePicker,
  Tooltip,
  Notification,
  Message,
  MessageBox,
  Loading,
  Tag,
  Button as elButton,
  Input,
  Autocomplete,
  Dialog,
  Select,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  Option,
  Radio,
  RadioGroup,
  Checkbox,
  Table as ElementTable,
  TableColumn as ElementTableColumn
} from 'element-ui';
import {
  BTable,
  BPagination,
  BCard,
  BButton,
  BForm,
  BFormGroup,
  BFormInput,
  BFormTextarea,
  BFormFile,
  BFormCheckbox,
  BFormRadio,
  BFormSelect,
  BInputGroup,
  BAlert,
  LayoutPlugin,
  BNavbar
} from 'bootstrap-vue';
import VueParticles from 'vue-particles';
import VueObserveVisibility from 'vue-observe-visibility';
import Config from './config';

Vue.use(VueObserveVisibility);
Vue.use(VueKonva);
Vue.use(VueParticles);

Vue.component('fai', FontAwesomeIcon);

// load element-ui components
Vue.use(VueScrollTo);
Vue.use(DatePicker);
Vue.use(Tooltip);
Vue.use(Tag);
Vue.use(elButton);
Vue.use(Input);
Vue.use(Autocomplete);
Vue.use(Dialog);
Vue.use(Select);
Vue.use(Option);
Vue.use(ElementTable);
Vue.use(ElementTableColumn);
Vue.use(Radio);
Vue.use(RadioGroup);
Vue.use(Checkbox);
Vue.use(Dropdown);
Vue.use(DropdownItem);
Vue.use(DropdownMenu);
// @ts-ignore
Vue.use(Loading.directive);
// load vue-bootstrap components
Vue.component('BTable', BTable);
Vue.component('BPagination', BPagination);
Vue.component('BCard', BCard);
Vue.component('BButton', BButton);
Vue.component('BForm', BForm);
Vue.component('BFormGroup', BFormGroup);
Vue.component('BFormInput', BFormInput);
Vue.component('BFormTextarea', BFormTextarea);
Vue.component('BFormFile', BFormFile);
Vue.component('BFormCheckbox', BFormCheckbox);
Vue.component('BFormRadio', BFormRadio);
Vue.component('BFormSelect', BFormSelect);
Vue.component('BInputGroup', BInputGroup);
Vue.component('BAlert', BAlert);
Vue.use(LayoutPlugin);
Vue.component('BNavbar', BNavbar);

Vue.prototype.$notify = Notification;
Vue.prototype.$msgbox = MessageBox;
Vue.prototype.$alert = MessageBox.alert;
Vue.prototype.$confirm = MessageBox.confirm;
Vue.prototype.$prompt = MessageBox.prompt;
Vue.prototype.$message = Message;

Vue.config.productionTip = false;

sync(store, router);

// load jwt before app init, the router beforeEnter hook will try to validate it
store.dispatch('loadJwtToken');

Vue.use(Meta);

Vue.use(VueI18n);
const i18n = new VueI18n({
  locale: 'en',
  messages: [] as any,
  missing: (locale: string, key: any, vm: Vue | undefined) => {
    translationSvc
      .getTranslation(locale, key)
      .then((value: string) => {
        const [group, item] = key.split('.');
        i18n.mergeLocaleMessage(locale, { [group]: { [item]: value } });
        vm && vm.$forceUpdate();
      })
      .catch(e => {});
    return '';
  }
});

const translationStoreElement = document.getElementById(
  Constants.TRANSLATIONS_STORE
);
if (translationStoreElement) {
  const translationData = JSON.parse(
    (translationStoreElement.getAttribute('data-translations') as string) ||
      '{}'
  );
  for (const key in translationData) {
    const [group, item] = key.split('.');
    const value = translationData[key];
    i18n.mergeLocaleMessage('en', { [group]: { [item]: value } });
  }
}

new Vue({
  el: '#upservice-admin',
  router,
  store,
  i18n,
  render: h => h(App)
});
